var _style, _ellipse, _circle, _circle2, _circle3, _circle4, _path, _path2, _path3, _path4, _path5, _circle5, _path6, _path7, _path8, _path9, _polygon, _path10, _circle6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllustrationNothingfound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 850 550",
    style: {
      enableBackground: "new 0 0 850 550"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#3F3D56;}\n\t.st1{opacity:5.000000e-02;enable-background:new    ;}\n\t.st2{fill:#D0CDE1;}\n\t.st3{opacity:0.1;enable-background:new    ;}\n\t.st4{fill:#2F2E41;}\n\t.st5{fill:#FFB8B8;}\n\t.st6{fill:url(#SVGID_1_);}\n\t.st7{fill:url(#SVGID_00000109718204599701040020000002352248260591201936_);}\n")), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 365.5,
    cy: 514.1,
    rx: 203.3,
    ry: 35.9
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 489.1,
    cy: 198.7,
    r: 198.7
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 489.1,
    cy: 198.7,
    r: 164
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 489.1,
    cy: 198.7,
    r: 134.4
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 489.1,
    cy: 198.7,
    r: 96.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M292.1,216.5c0,0-15.6,44-8.7,59.6c6.9,15.6,17.9,30.7,17.9,30.7S297.4,219.4,292.1,216.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M292.1,216.5c0,0-15.6,44-8.7,59.6c6.9,15.6,17.9,30.7,17.9,30.7S297.4,219.4,292.1,216.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M303.1,318.3c0,0-1.2,11-1.7,11.6s0.6,1.7,0,3.5c-0.6,1.7-1.2,4.1,0,4.6s-6.4,51.5-6.4,51.5s-18.5,24.3-11,62.5 l2.3,38.8c0,0,17.9,1.2,17.9-5.2c0,0-1.2-7.5-1.2-11c0-3.5,2.9-3.5,1.2-5.2s-1.7-2.9-1.7-2.9s2.9-2.3,2.3-2.9 c-0.6-0.6,5.2-41.7,5.2-41.7s6.4-6.4,6.4-9.8v-3.5c0,0,2.9-7.5,2.9-8.1c0-0.6,15.6-35.9,15.6-35.9l6.4,25.5l6.9,36.5 c0,0,3.5,33,10.4,45.7c0,0,12.2,41.7,12.2,40.5c0-1.2,20.3-4.1,19.7-9.3c-0.6-5.2-12.2-78.1-12.2-78.1l2.9-108.2L303.1,318.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M287.5,487.9c0,0-15.6,30.7-5.2,31.8c10.4,1.2,14.5,1.2,19.1-3.5c2.5-2.5,7.7-5.9,11.8-8.5 c5-3,7.8-8.7,7.2-14.5c-0.3-2.8-1.4-5.2-4-5.4c-6.9-0.6-15-6.9-15-6.9L287.5,487.9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M373.7,510.4c0,0-15.6,30.7-5.2,31.8c10.4,1.2,14.5,1.2,19.1-3.5c2.5-2.5,7.7-5.9,11.8-8.5 c5-3,7.8-8.7,7.2-14.5c-0.3-2.8-1.4-5.2-4-5.4c-6.9-0.6-15-6.9-15-6.9L373.7,510.4z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 357.2,
    cy: 142,
    r: 24.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M341.6,150c0,0-17.4,32-18.8,32s31.3,10.4,31.3,10.4s9-30.6,10.4-33.4L341.6,150z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M368.2,185c0,0-34.7-19.1-38.2-18.5c-3.5,0.6-40.5,33-39.9,46.3c0.6,13.3,5.2,35.3,5.2,35.3s1.7,61.3,5.2,61.9 c3.5,0.6-0.6,11,0.6,11s81,0,81.6-1.7S368.2,185,368.2,185z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M387.6,322.4c0,0,11,33.6,1.7,32.4S376,325.9,376,325.9L387.6,322.4z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M358.1,182.9c0,0-21.4,4.6-17.9,33.6s9.8,57.9,9.8,57.9l21.4,46.9l2.3,8.7l15.6-4.1l-11.6-67.1 c0,0-4.1-71.7-9.3-74.1C365.2,183.3,361.7,182.7,358.1,182.9z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "345.1,273.5 371.7,320.9 349.3,270.9 "
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M381.4,134.8l0.1-1.9l3.7,0.9c-0.1-1.2-0.7-2.3-1.7-3l3.9-0.2c-6.7-9.5-16.9-15.8-28.4-17.6 c-8.5-1.2-18,0.6-23.8,6.9c-2.8,3.1-4.6,7-5.9,10.9c-2.3,7.3-2.8,16.1,2.1,22c4.9,6.1,13.6,7.2,21.4,8c2.7,0.3,5.6,0.5,8.1-0.6 c0.3-2.9-0.1-5.8-1.1-8.6c-0.4-0.9-0.6-1.8-0.6-2.7c0.3-2.3,3.4-2.9,5.8-2.6c2.3,0.3,5.1,0.8,6.6-1c1-1.2,1-3,1.1-4.6 C373.1,136.5,381.4,135.7,381.4,134.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 502.2768,
    y1: 490.683,
    x2: 558.9575,
    y2: 490.683
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#ECB365"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F37335"
    }
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 530.6,
    cy: 490.7,
    r: 28.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000097490420300605019330000015182815250733583019_",
    gradientUnits: "userSpaceOnUse",
    x1: 169.4428,
    y1: 453.1156,
    x2: 226.1234,
    y2: 453.1156
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#ECB365"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F37335"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000097490420300605019330000015182815250733583019_)"
    },
    d: "M213,456.9c3.3-3.6,5.3-8.4,5.3-13.6 c0-8.7-5.5-16.2-13.2-19.1c4.3-2.5,7.3-7.2,7.3-12.5c0-8-6.5-14.5-14.5-14.5c-8,0-14.5,6.5-14.5,14.5c0,5.4,2.9,10,7.3,12.5 c-7.7,2.9-13.2,10.4-13.2,19.1c0,5.2,2,10,5.3,13.6c-7.9,5-13.2,13.9-13.2,23.9c0,15.7,12.7,28.3,28.3,28.3 c15.7,0,28.3-12.7,28.3-28.3C226.1,470.7,220.9,461.9,213,456.9z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationNothingfound);
export default __webpack_public_path__ + "static/media/illustration_nothingfound.44b12c69bec3fee3ab6828a93d922856.svg";
export { ForwardRef as ReactComponent };